import { authFetch } from "../helpers/FetchHelpers";
class DataService {
    entity = "";
    constructor(entity) {
        this.entity = entity;
    }

    getList(keyword, currentPage, perPage) {
        keyword = typeof keyword !== 'undefined' ? keyword : ''

        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity  + '/list?page=' + currentPage + '&per_page=' + perPage + '&keyword=' + keyword,
                        'GET', null);
    }

    get(clauses) {
        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity + '?' + clauses, 'GET', null);
    }

    add(item) {
        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity, 'POST', JSON.stringify(item));
    }

    update(item) {
        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity, 'PUT', JSON.stringify(item));
    }

}

export default DataService;